import CustomSelect from "../../../common/interactive/CustomSelect"
import { useDispatch, useSelector } from "react-redux"
import { filterActions } from "../../../../store/filter"
import { workqueueActions } from "../../../../store/workqueue"
import { setFiltersInLocalStorage } from "../../../../lib/filters"
import classes from './PerPage.module.css'
import { historyActions } from "../../../../store/history"
import { exportsActions } from "../../../../store/exports"
import { referralsActions } from "../../../../store/referrals"
import { tasksActions } from "../../../../store/tasks"
import { transfersActions } from "../../../../store/transfers"
import { appointmentsActions } from "../../../../store/appointments"
import { fetchWorkQNow } from "../../../../lib/hooks"

const SLICE_API_TYPES = new Set(['history', 'exports', 'referrals', 'tasks', 'transfers', 'appointments'])

export default function PerPage({data, apiType}) {
    const dispatch = useDispatch() 
    // let { workqSlug } = useParams();
    const workq = useSelector(state => state.workqueue.selectedWorkQueue)
    const selectedFilters = useSelector(state => state.filter.filters)

    const setPerPage = (value) => {        
        if (value.data.value != data?.meta?.per_page) {
            const nextFilters = { ...selectedFilters, per_page: value.data.value }
            // For WorkQ list, start the request immediately (don't wait for effect).
            // In Work Queues, `apiType` is actually the workq slug.
            const isWorkQList = !apiType || !SLICE_API_TYPES.has(apiType)
            if (isWorkQList) {
                const workqSlug = apiType || workq?.slug
                if (typeof window !== 'undefined') {
                    window.__skipNextWorkQFetch = { slug: workqSlug, at: typeof performance !== 'undefined' ? performance.now() : Date.now() }
                }
                fetchWorkQNow(workqSlug, { filters: nextFilters, onPage: 1 })

                // Defer Redux updates so we don't block the main thread before the request starts.
                setTimeout(() => {
                    dispatch(filterActions.setFiltersMultiple(nextFilters))
                    dispatch(filterActions.setCurrentPage(1))
                    setFiltersInLocalStorage(nextFilters, workq?.slug)
                }, 0)

                return
            }

            // Persist + redux updates
            dispatch(filterActions.setFiltersMultiple(nextFilters))
            setFiltersInLocalStorage(nextFilters, workq?.slug)
            if (data?.meta?.current_page != 1) {
                if (apiType == 'history') {
                    dispatch(historyActions.setCurrentPage(1))
                } else if (apiType == 'exports') {
                    dispatch(exportsActions.setCurrentPage(1))
                } else if (apiType == 'referrals') {
                    dispatch(referralsActions.setCurrentPage(1))
                } else if (apiType == 'tasks') {
                    dispatch(tasksActions.setCurrentPage(1))
                } else if (apiType == 'transfers') {
                    dispatch(transfersActions.setCurrentPage(1))
                } else if (apiType == 'appointments') {
                    dispatch(appointmentsActions.setCurrentPage(1))
                } else {
                    dispatch(filterActions.setCurrentPage(1))
                }
            } else {
                dispatch(workqueueActions.setRefreshApi())
            }

        }
    }
    return (
        <div style={{color: 'var(--text)'}} className={`${classes.container} flex-container`}>
                {/* <span>Items per page</span> */}
                <CustomSelect appendToText='Items per page' reverseDrawer={true} thin_select={true} name="pagination"  optionsData={[{label: '20', value: 20}, {label: '30', value: 30}, {label: '50', value: 50}, {label: '70', value: 70}, {label: '100', value: 100}]} preSelectedValue={data.meta.per_page} action={setPerPage} minWidth={180}/>
        </div>
    )
}